import Vue from "vue";
import VueRouter from "vue-router";
import ProjectList from "@/views/projects/List.vue";
import Project from "@/views/projects/Project";
Vue.use(VueRouter);
import store from "@/store";
import Home from "@/views/Home";
import Diagnose from "@/views/annotator/Diagnose";
import DiagnosisDashboard from "@/views/annotator/DiagnosisDashboard";
import Dashboard from "@/views/annotator/Dashboard";
import Annotate from "@/views/annotator/Annotate";
import AnnotationValidation from "@/views/projects/AnnotationValidation";
import ViewSlide from "@/views/ViewSlide";
import Form from "@/views/contributor/Form";
import {
  ROLE_IMAGE_OWNER,
  ROLE_PATHOLOGIST,
  ROLE_RESEARCHER,
  ROLE_TESTER
} from "@/constants";
import View401 from "@/views/401";
import Registration from "@/views/registration/Registration";
import Success from "@/views/registration/Success";
import List from "@/views/annotator/List";
import Visualization from "@/views/contributor/Visualization";
import Tokens from "@/views/Tokens";
import ContributorList from "@/views/contributor/List";
import SetupOrganization from "@/views/registration/SetupOrganization";
import ServiceList from "@/views/service/ServiceList";
import ServiceView from "@/views/service/ServiceView";
import ServiceReportForm from "@/views/service/ServiceReportForm";
const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    meta: { requiresAuth: false }
  },
  {
    path: "/projects",
    name: "project-list",
    component: ProjectList,
    meta: { requiresAuth: true, roles: [ROLE_RESEARCHER] }
  },
  {
    path: "/projects/:id",
    name: "project",
    component: Project,
    meta: { requiresAuth: true, roles: [ROLE_RESEARCHER] }
  },
  {
    path: "/annotator",
    name: "annotator-dashboard",
    component: Dashboard,
    meta: { requiresAuth: true, roles: [ROLE_PATHOLOGIST] }
  },
  {
    path: "/diagnosis",
    name: "diagnosis-dashboard",
    component: DiagnosisDashboard,
    meta: { requiresAuth: true, roles: [ROLE_TESTER] }
  },
  {
    path: "/diagnose/:id",
    name: "diagnose-visualize",
    component: Diagnose,
    meta: { requiresAuth: true, roles: [ROLE_TESTER] }
  },
  {
    path: "/annotator/list",
    name: "annotator-list",
    component: List,
    meta: { requiresAuth: true, roles: [ROLE_PATHOLOGIST] }
  },
  {
    path: "/annotator/:id",
    name: "annotator-visualize",
    component: Annotate,
    meta: { requiresAuth: true, roles: [ROLE_PATHOLOGIST] }
  },
  {
    path: "/validate/:id",
    name: "annotator-validation",
    component: AnnotationValidation,
    meta: { requiresAuth: true, roles: [ROLE_RESEARCHER] }
  },
  {
    path: "/view",
    name: "slide-view",
    component: ViewSlide,
    // meta: { requiresAuth: true, roles: [ROLE_RESEARCHER] }
    meta: { requiresAuth: true, roles: [ROLE_RESEARCHER, ROLE_PATHOLOGIST] }
  },
  {
    path: "/tokens",
    name: "tokens-list",
    component: Tokens,
    meta: { requiresAuth: true, roles: [ROLE_IMAGE_OWNER, ROLE_PATHOLOGIST] }
  },
  {
    path: "/contributor/",
    name: "contributor",
    component: Form,
    meta: { requiresAuth: true, roles: [ROLE_IMAGE_OWNER] }
  },
  {
    path: "/contributor/list",
    name: "contributor-list",
    component: ContributorList,
    meta: { requiresAuth: true, roles: [ROLE_IMAGE_OWNER] }
  },
  {
    path: "/contributor/visualize",
    name: "contributor-visualize",
    component: Visualization,
    meta: { requiresAuth: true, roles: [ROLE_IMAGE_OWNER] }
  },
  {
    path: "/registration/",
    name: "registration",
    component: Registration,
    meta: { requiresAuth: false }
  },
  {
    path: "/registration/success",
    name: "registration-success",
    component: Success,
    meta: { requiresAuth: false }
  },
  {
    path: "/setup",
    name: "setup-organization",
    component: SetupOrganization,
    meta: { requiresAuth: true, roles: [ROLE_IMAGE_OWNER] }
  },
  {
    path: "/service",
    name: "service",
    component: ServiceList,
    meta: { requiresAuth: true, roles: [ROLE_PATHOLOGIST] }
  },
  {
    path: "/service/view/:id",
    name: "service-view",
    component: ServiceView,
    meta: { requiresAuth: true, roles: [ROLE_PATHOLOGIST] }
  },
  {
    path: "/service/report/:id",
    name: "service-reportform",
    component: ServiceReportForm,
    meta: { requiresAuth: true, roles: [ROLE_PATHOLOGIST] }
  },
  {
    path: "/not-allowed",
    name: "401",
    component: View401
    // meta: { requiresAuth: true }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});
router.beforeEach(async (to, from, next) => {
  const keycloak = store.state.authentication.keycloak;
  if (to.meta.requiresAuth) {
    // Check if user is logged in
    if (!keycloak.authenticated) {
      keycloak.login({
        redirectUri: process.env.VUE_APP_REDIRECT_URI_AFTER_LOGIN
      });
      return;
    }
  }

  if (to.meta.roles !== undefined) {
    if (store.getters.roles.some(e => to.meta.roles.includes(e))) {
      next();
      return;
    } else {
      next({ name: "401" });
      return;
    }
  }

  next();
});

export default router;
